<template>
  <action-menu-v2 ref="actionMenuRef" teleport-menu :offset>
    <template #trigger="{ showMenu }">
      <div
        class="px-2 py-1 rounded border text-headline-new hover:bg-ghost-white hover:cursor-pointer shrink-0"
        :class="
          showMenu
            ? 'border-primary'
            : 'border-divider bg-white hover:border-silver'
        "
      >
        +{{ remainingCount }}
      </div>
    </template>

    <extra-file
      v-for="(file, index) in remainingFiles"
      :key="index"
      :file="file"
      @file:open="openPreview"
      @file:remove="deleteFile"
    />
  </action-menu-v2>
  <document-preview-modal
    v-if="showPreviewModal && previewItem"
    :item="previewItem"
    :close="closePreview"
  />
</template>
<script setup lang="ts">
import { computed, ref, useTemplateRef } from "vue";

import { storeToRefs } from "pinia";

import { sleep } from "@/helpers/common";
import { useEmitter } from "@/hooks/common";
import { useFilePreview } from "@/hooks/useFilePreview";
import { useAiAgentsStore } from "@/stores/ai/agents";

import ExtraFile from "@/components/cmdK/chat/files/ExtraFile.vue";
import DocumentPreviewModal from "@/components/deals/documents/DocumentPreviewModal.vue";
import ActionMenuV2 from "@/components/ui/ActionMenuV2.vue";

const { remainingFiles } = defineProps<{ remainingFiles: File[] }>();
const emit = defineEmits<{ "file:remove": [File] }>();

const offset = ref({ top: -5, left: 45 });

const emitter = useEmitter();

const { agentSessionInfo } = storeToRefs(useAiAgentsStore());

const actionMenuRef =
  useTemplateRef<InstanceType<typeof ActionMenuV2>>("actionMenuRef");

emitter?.on("CMDK_DRAG_START", () => {
  actionMenuRef.value?.closeMenu();
});

const remainingCount = computed(() => remainingFiles.length);

const { showPreviewModal, previewItem, openPreview, closePreview } =
  useFilePreview();

const deleteFile = async (file: File) => {
  agentSessionInfo.value.hasActiveOverlay = true;
  emit("file:remove", file);
  await sleep(100);
  agentSessionInfo.value.hasActiveOverlay = false;
};
</script>
